import React from "react";

const ResumenAlumno = ({
    datosInscripcion = {},
    color = "bg-primarioMira",
    carnet = ''
}) => {
    console.log('carnet res',carnet)
    return (        
        <>
            <div className={`grid content-center ${color} rounded-md p-1 m-1 text-center`}>
                {carnet !== '' ? (
                    <div>
                        <p className="inline text-base text-white">
                            Carnet:{" "}
                        </p>
                        <p className="inline text-base text-secundario">
                            {carnet}
                        </p>
                    </div>
                ) : null}
                {datosInscripcion.Nombres !== undefined ? (
                    <div>
                        <p className="inline text-base text-white">
                            Nombre completo:{" "}
                        </p>
                        <p className="inline text-base text-secundario">
                            {datosInscripcion.Nombres} {datosInscripcion.Apellidos}
                        </p>
                    </div>
                ) : null}
                {datosInscripcion.Email !== undefined ? (
                    <div>
                        <p className="inline text-base text-white">
                            Email:{" "}
                        </p>
                        <p className="inline text-base text-secundario">
                            {datosInscripcion.Email}
                        </p>
                    </div>
                ) : null}
                {datosInscripcion.Celular !== undefined ? (
                    <div>
                        <p className="inline text-base text-white">
                            Celular:{" "}
                        </p>
                        <p className="inline text-base text-secundario">
                            {datosInscripcion.Celular}
                        </p>
                    </div>
                ) : <div>
                    <p className="inline text-base text-white">
                        Celular:{" "}
                    </p>
                    <p className="inline text-base text-secundario">
                        {datosInscripcion.Cel}
                    </p>
                </div>}
            </div>
        </>
    );
};

export default ResumenAlumno;
